<script lang="ts">
	import AchievementsWidget from '$pages/achievements/AchievementsWidget.svelte';
	import type { Achievement } from '../../domain/Achievement';
	import { achievementResponseStore, achievementsStore } from '../../store/AchievementStore';
	import { logger } from '../../logger';

	const { data }: { data: { showAchievementsWidget: boolean, enableNewAchievementModule: boolean, achievements: Achievement[], points: number } } = $props();

	$effect.pre(() => {
		if (data.achievements) {
			if (data.enableNewAchievementModule) {
				achievementResponseStore.set({ actualAchievements: data.achievements, pastAchievements: [], batchId: 0 });
			} else {
				achievementsStore.set(data.achievements);
			}
		}
	});

</script>

{#if data.showAchievementsWidget && data.achievements.length > 0}
	<AchievementsWidget points={data.points} enableNewAchievementModule={data.enableNewAchievementModule}/>
{/if}
